import { useSearchParams } from "next/navigation";
import { useMemo } from "react";
import {
  readSapFailureFlags,
  SAP_FAILURE_PARAMS,
  type SapFailureFlags,
} from "./sap-failure";

/**
 * The current URL's SAP failure flags, for client components to pass to
 * server actions. Referentially stable while the params don't change, so it
 * is safe in effect dependencies.
 */
export function useSapFailureFlags(): SapFailureFlags | undefined {
  const searchParams = useSearchParams();
  const fetchParam = searchParams.get(SAP_FAILURE_PARAMS.fetch) ?? undefined;
  const postParam = searchParams.get(SAP_FAILURE_PARAMS.post) ?? undefined;
  return useMemo(
    () =>
      readSapFailureFlags({
        [SAP_FAILURE_PARAMS.fetch]: fetchParam,
        [SAP_FAILURE_PARAMS.post]: postParam,
      }),
    [fetchParam, postParam],
  );
}
